import { useMutation } from '@apollo/client';

import { updateSupplierMutation } from './gql';
import { SupplierUpdateArgs, MutationResult } from './interface';

export const useUpdateSupplierGql = () => {
  const [runUpdateSupplierMutation, { data, loading, error }] = useMutation<MutationResult, SupplierUpdateArgs>(
    updateSupplierMutation,
    {
      context: {
        headers: {
          userFunctionKey: '9f61408e3afb633e50cdf1b20de6f466'
        }
      }
    }
  );

  return {
    runUpdateSupplierMutation,
    loadingUpdateSupplier: loading,
    message: data?.message || '',
    errorUpdateSupplier: error
  };
};
